// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__lLcOT","closeIcon":"Modal_closeIcon__0a9as","modalOverlay":"Modal_modalOverlay__acNWu","modalContent":"Modal_modalContent__j1VxT"};